import { Box, keyframes } from '@chakra-ui/react';
import { OTPInput, REGEXP_ONLY_DIGITS, SlotProps } from 'input-otp';

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

type PinPadProps = {
  value: string;
  onChange: (value: string) => void;
  length?: number;
  isDisabled?: boolean;
  autoFocus?: boolean;
};

const Slot = ({ char, isActive, hasFakeCaret }: SlotProps) => (
  <Box
    w="45px"
    h="50px"
    bg="white"
    border="1px solid"
    borderColor={isActive ? 'oceanBoatBlue' : 'grayDarkBackground'}
    borderRadius="3px"
    mx="5px"
    display="flex"
    alignItems="center"
    justifyContent="center"
    fontWeight="medium"
    color="charcoal"
    fontSize="16px"
    transition="border-color 0.15s"
  >
    {char}
    {hasFakeCaret && (
      <Box w="1px" h="20px" bg="charcoal" animation={`${blink} 1s ease-in-out infinite`} />
    )}
  </Box>
);

const PinPad = ({
  value,
  onChange,
  length = 6,
  isDisabled = false,
  autoFocus = false,
}: PinPadProps) => {
  return (
    <OTPInput
      value={value}
      onChange={onChange}
      maxLength={length}
      disabled={isDisabled}
      autoFocus={autoFocus}
      inputMode="numeric"
      pattern={REGEXP_ONLY_DIGITS}
      render={({ slots }) => (
        <Box display="flex" justifyContent="center">
          {slots.map((slot, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Slot key={`pinpad-item-${i}`} {...slot} />
          ))}
        </Box>
      )}
    />
  );
};

export default PinPad;
